export function setToken(token) {
  localStorage.setItem("token", token);
}
export function getToken() {
  return {
    token: localStorage.getItem("token"),
  };
}
export function removeToken() {
  localStorage.removeItem("token");
}

export function setPage(page) {
  localStorage.setItem("page", page);
}
export function getPage() {
  return localStorage.getItem("page");
}
export function removePage() {
  return localStorage.removeItem("page");
}

export function setModeImage(value) {
  localStorage.setItem("modeImage", value);
}
export function getModeImage() {
  return JSON.parse(localStorage.getItem("modeImage"));
}
export function removeModeImage() {
  return localStorage.removeItem("modeImage");
}
